package com.mgacreative.hotel.domain.demo

import com.mgacreative.hotel.domain.model.*
import com.mgacreative.hotel.domain.repository.CurrentAccount
import com.mgacreative.hotel.domain.repository.InventoryItem
import kotlinx.coroutines.flow.MutableStateFlow

object DemoDataProvider {
    const val DEMO_TENANT_ID = "demo-tenant-id"

    // 1. Rooms
    val roomsState = MutableStateFlow<List<Room>>(
        listOf(
            Room(id = "demo-r-101", tenantId = DEMO_TENANT_ID, roomType = "Deluxe", roomNumber = "101", status = "OCCUPIED"),
            Room(id = "demo-r-102", tenantId = DEMO_TENANT_ID, roomType = "Standard", roomNumber = "102", status = "CLEAN"),
            Room(id = "demo-r-103", tenantId = DEMO_TENANT_ID, roomType = "Suite", roomNumber = "103", status = "DIRTY"),
            Room(id = "demo-r-104", tenantId = DEMO_TENANT_ID, roomType = "Single", roomNumber = "104", status = "CLEAN"),
            Room(id = "demo-r-201", tenantId = DEMO_TENANT_ID, roomType = "Executive", roomNumber = "201", status = "OCCUPIED"),
            Room(id = "demo-r-202", tenantId = DEMO_TENANT_ID, roomType = "Family", roomNumber = "202", status = "CLEAN"),
            Room(id = "demo-r-203", tenantId = DEMO_TENANT_ID, roomType = "Double", roomNumber = "203", status = "IN_PROGRESS"),
            Room(id = "demo-r-204", tenantId = DEMO_TENANT_ID, roomType = "Twin", roomNumber = "204", status = "CLEAN"),
            Room(id = "demo-r-301", tenantId = DEMO_TENANT_ID, roomType = "King Suite", roomNumber = "301", status = "OCCUPIED"),
            Room(id = "demo-r-302", tenantId = DEMO_TENANT_ID, roomType = "Junior Suite", roomNumber = "302", status = "MAINTENANCE")
        )
    )

    // 2. Guests
    val guestsState = MutableStateFlow<List<Guest>>(
        listOf(
            Guest(id = "demo-g-1", tenantId = DEMO_TENANT_ID, firstName = "Ahmet", lastName = "Yılmaz", idPassportNo = "12345678901", country = "Türkiye", phone = "+90 532 111 22 33", email = "ahmet.yilmaz@email.com"),
            Guest(id = "demo-g-2", tenantId = DEMO_TENANT_ID, firstName = "Ayşe", lastName = "Demir", idPassportNo = "98765432100", country = "Türkiye", phone = "+90 533 222 33 44", email = "ayse.demir@email.com"),
            Guest(id = "demo-g-3", tenantId = DEMO_TENANT_ID, firstName = "Alexander", lastName = "Ivanov", idPassportNo = "RU78945612", country = "Rusya", phone = "+7 999 123 45 67", email = "alex.ivanov@mail.ru"),
            Guest(id = "demo-g-4", tenantId = DEMO_TENANT_ID, firstName = "Elena", lastName = "Rostova", idPassportNo = "RU45612378", country = "Rusya", phone = "+7 999 765 43 21", email = "elena.rostova@mail.ru"),
            Guest(id = "demo-g-5", tenantId = DEMO_TENANT_ID, firstName = "Mehmet", lastName = "Kaya", idPassportNo = "11223344556", country = "Türkiye", phone = "+90 535 333 44 55", email = "mehmet.kaya@email.com")
        )
    )

    // 3. Reservations
    val reservationsState = MutableStateFlow<List<Reservation>>(
        listOf(
            Reservation(
                id = "demo-res-1",
                tenantId = DEMO_TENANT_ID,
                guestId = "demo-g-1",
                roomId = "demo-r-101",
                checkInDate = "2026-09-05",
                checkOutDate = "2026-09-10",
                status = "CHECKED_IN",
                roomType = "Deluxe",
                totalPrice = 12500.0,
                specialNotes = "Yüksek kat ve sessiz oda talebi",
                adultsCount = 2,
                childrenCount = 0,
                guests = Guest(id = "demo-g-1", tenantId = DEMO_TENANT_ID, firstName = "Ahmet", lastName = "Yılmaz", idPassportNo = "12345678901", country = "Türkiye", phone = "+90 532 111 22 33", email = "ahmet.yilmaz@email.com"),
                rooms = Room(id = "demo-r-101", tenantId = DEMO_TENANT_ID, roomType = "Deluxe", roomNumber = "101", status = "OCCUPIED")
            ),
            Reservation(
                id = "demo-res-2",
                tenantId = DEMO_TENANT_ID,
                guestId = "demo-g-3",
                roomId = "demo-r-201",
                checkInDate = "2026-09-06",
                checkOutDate = "2026-09-12",
                status = "CHECKED_IN",
                roomType = "Executive",
                totalPrice = 18000.0,
                specialNotes = "Havalimanı transferi yapıldı",
                adultsCount = 2,
                childrenCount = 1,
                guests = Guest(id = "demo-g-3", tenantId = DEMO_TENANT_ID, firstName = "Alexander", lastName = "Ivanov", idPassportNo = "RU78945612", country = "Rusya", phone = "+7 999 123 45 67", email = "alex.ivanov@mail.ru"),
                rooms = Room(id = "demo-r-201", tenantId = DEMO_TENANT_ID, roomType = "Executive", roomNumber = "201", status = "OCCUPIED")
            ),
            Reservation(
                id = "demo-res-3",
                tenantId = DEMO_TENANT_ID,
                guestId = "demo-g-4",
                roomId = "demo-r-301",
                checkInDate = "2026-09-07",
                checkOutDate = "2026-09-14",
                status = "CHECKED_IN",
                roomType = "King Suite",
                totalPrice = 28000.0,
                specialNotes = "Balayı konsepti ikramları hazırlandı",
                adultsCount = 2,
                childrenCount = 0,
                guests = Guest(id = "demo-g-4", tenantId = DEMO_TENANT_ID, firstName = "Elena", lastName = "Rostova", idPassportNo = "RU45612378", country = "Rusya", phone = "+7 999 765 43 21", email = "elena.rostova@mail.ru"),
                rooms = Room(id = "demo-r-301", tenantId = DEMO_TENANT_ID, roomType = "King Suite", roomNumber = "301", status = "OCCUPIED")
            ),
            Reservation(
                id = "demo-res-4",
                tenantId = DEMO_TENANT_ID,
                guestId = "demo-g-2",
                roomId = "demo-r-102",
                checkInDate = "2026-09-08",
                checkOutDate = "2026-09-11",
                status = "CONFIRMED",
                roomType = "Standard",
                totalPrice = 7500.0,
                specialNotes = "Geç giriş yapabilir",
                adultsCount = 1,
                childrenCount = 0,
                guests = Guest(id = "demo-g-2", tenantId = DEMO_TENANT_ID, firstName = "Ayşe", lastName = "Demir", idPassportNo = "98765432100", country = "Türkiye", phone = "+90 533 222 33 44", email = "ayse.demir@email.com"),
                rooms = Room(id = "demo-r-102", tenantId = DEMO_TENANT_ID, roomType = "Standard", roomNumber = "102", status = "CLEAN")
            )
        )
    )

    // 4. Cash Movements & Current Accounts
    val cashMovementsState = MutableStateFlow<List<CashMovement>>(
        listOf(
            CashMovement(id = "cm-1", tenant_id = DEMO_TENANT_ID, type = "INCOME", amount = 12500.0, description = "Oda 101 Konaklama Tahsilatı (Kredi Kartı)", movement_date = "2026-09-07", created_at = "2026-09-07T10:30:00Z"),
            CashMovement(id = "cm-2", tenant_id = DEMO_TENANT_ID, type = "INCOME", amount = 1800.0, description = "Restoran A La Carte Adisyon Tahsilatı", movement_date = "2026-09-07", created_at = "2026-09-07T13:45:00Z"),
            CashMovement(id = "cm-3", tenant_id = DEMO_TENANT_ID, type = "EXPENSE", amount = 3400.0, description = "Mutfak Günlük Sebze/Meyve Tedariği", movement_date = "2026-09-07", created_at = "2026-09-07T08:15:00Z"),
            CashMovement(id = "cm-4", tenant_id = DEMO_TENANT_ID, type = "INCOME", amount = 18000.0, description = "Oda 201 Konaklama Peşinatı", movement_date = "2026-09-06", created_at = "2026-09-06T15:20:00Z"),
            CashMovement(id = "cm-5", tenant_id = DEMO_TENANT_ID, type = "EXPENSE", amount = 1200.0, description = "Temizlik ve Buklet Malzemesi Alımı", movement_date = "2026-09-06", created_at = "2026-09-06T11:00:00Z")
        )
    )

    val currentAccountsState = MutableStateFlow<List<CurrentAccount>>(
        listOf(
            CurrentAccount(id = "ca-1", tenant_id = DEMO_TENANT_ID, name = "Booking.com B.V.", type = "CUSTOMER", balance = 45200.0),
            CurrentAccount(id = "ca-2", tenant_id = DEMO_TENANT_ID, name = "OtelZ Turizm A.Ş.", type = "CUSTOMER", balance = 18500.0),
            CurrentAccount(id = "ca-3", tenant_id = DEMO_TENANT_ID, name = "Akdeniz Gıda Toptan", type = "SUPPLIER", balance = -12400.0),
            CurrentAccount(id = "ca-4", tenant_id = DEMO_TENANT_ID, name = "Kristal Çamaşırhane Hizmetleri", type = "SUPPLIER", balance = -4800.0)
        )
    )

    // 5. Staff & Shifts
    val staffState = MutableStateFlow<List<Staff>>(
        listOf(
            Staff(id = "st-1", tenant_id = DEMO_TENANT_ID, full_name = "Caner Özkan", department = "Ön Büro"),
            Staff(id = "st-2", tenant_id = DEMO_TENANT_ID, full_name = "Zeynep Arslan", department = "Kat Hizmetleri"),
            Staff(id = "st-3", tenant_id = DEMO_TENANT_ID, full_name = "Burak Çetin", department = "Restoran & Bar"),
            Staff(id = "st-4", tenant_id = DEMO_TENANT_ID, full_name = "Mustafa Yıldız", department = "Teknik Servis"),
            Staff(id = "st-5", tenant_id = DEMO_TENANT_ID, full_name = "Selin Aydın", department = "Muhasebe")
        )
    )

    val shiftsState = MutableStateFlow<List<Shift>>(
        listOf(
            Shift(id = "sh-1", tenant_id = DEMO_TENANT_ID, staff_id = "st-1", date = "2026-09-07", start_time = "08:00", end_time = "16:00", role = "Resepsiyonist", status = "COMPLETED"),
            Shift(id = "sh-2", tenant_id = DEMO_TENANT_ID, staff_id = "st-2", date = "2026-09-07", start_time = "08:30", end_time = "17:00", role = "Kat Görevlisi", status = "ACTIVE"),
            Shift(id = "sh-3", tenant_id = DEMO_TENANT_ID, staff_id = "st-3", date = "2026-09-07", start_time = "12:00", end_time = "22:00", role = "Barmen/Garson", status = "ACTIVE"),
            Shift(id = "sh-4", tenant_id = DEMO_TENANT_ID, staff_id = "st-4", date = "2026-09-07", start_time = "09:00", end_time = "18:00", role = "Teknisyen", status = "SCHEDULED")
        )
    )

    // 6. POS Categories & Items
    val posCategoriesState = MutableStateFlow<List<PosCategory>>(
        listOf(
            PosCategory(id = "pos-c-1", tenant_id = DEMO_TENANT_ID, name = "Sıcak & Soğuk İçecekler"),
            PosCategory(id = "pos-c-2", tenant_id = DEMO_TENANT_ID, name = "A La Carte Mutfak"),
            PosCategory(id = "pos-c-3", tenant_id = DEMO_TENANT_ID, name = "Bar & Kokteyller"),
            PosCategory(id = "pos-c-4", tenant_id = DEMO_TENANT_ID, name = "Spa & Masaj Hizmetleri")
        )
    )

    val posItemsState = MutableStateFlow<List<PosItem>>(
        listOf(
            PosItem(id = "pos-i-1", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-1", name = "Türk Kahvesi", price = 80.0, is_available = true),
            PosItem(id = "pos-i-2", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-1", name = "Taze Portakal Suyu", price = 120.0, is_available = true),
            PosItem(id = "pos-i-3", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-2", name = "Izgara Somon", price = 480.0, is_available = true),
            PosItem(id = "pos-i-4", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-2", name = "Dana Bonfile", price = 650.0, is_available = true),
            PosItem(id = "pos-i-5", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-3", name = "Mojito", price = 320.0, is_available = true),
            PosItem(id = "pos-i-6", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-3", name = "Yerli Bira 50cl", price = 210.0, is_available = true),
            PosItem(id = "pos-i-7", tenant_id = DEMO_TENANT_ID, category_id = "pos-c-4", name = "Aromaterapi Masajı (50 Dk)", price = 1500.0, is_available = true)
        )
    )

    val posOrdersState = MutableStateFlow<List<PosOrder>>(emptyList())

    // 7. Inventory Items
    val inventoryItemsState = MutableStateFlow<List<InventoryItem>>(
        listOf(
            InventoryItem(id = "inv-1", tenant_id = DEMO_TENANT_ID, name = "Şampuan 50ml Buklet", category = "Buklet", quantity = 340, min_threshold = 50, unit = "Adet"),
            InventoryItem(id = "inv-2", tenant_id = DEMO_TENANT_ID, name = "El Havlusu", category = "Tekstil", quantity = 120, min_threshold = 30, unit = "Adet"),
            InventoryItem(id = "inv-3", tenant_id = DEMO_TENANT_ID, name = "Banyo Havlusu", category = "Tekstil", quantity = 95, min_threshold = 40, unit = "Adet"),
            InventoryItem(id = "inv-4", tenant_id = DEMO_TENANT_ID, name = "Çift Kişilik Çarşaf", category = "Tekstil", quantity = 80, min_threshold = 25, unit = "Adet"),
            InventoryItem(id = "inv-5", tenant_id = DEMO_TENANT_ID, name = "Masa Şarabı 75cl", category = "F&B", quantity = 48, min_threshold = 15, unit = "Şişe")
        )
    )

    // 8. Departments
    val departmentsState = MutableStateFlow<List<Department>>(
        listOf(
            Department(id = "dep-1", tenant_id = DEMO_TENANT_ID, name = "Ön Büro & Resepsiyon", permissions = listOf("Dashboard", "Rooms", "Reservations", "CheckIn", "Guest")),
            Department(id = "dep-2", tenant_id = DEMO_TENANT_ID, name = "Kat Hizmetleri (Housekeeping)", permissions = listOf("Housekeeping", "Rooms")),
            Department(id = "dep-3", tenant_id = DEMO_TENANT_ID, name = "Yiyecek & İçecek (POS)", permissions = listOf("Pos", "Inventory")),
            Department(id = "dep-4", tenant_id = DEMO_TENANT_ID, name = "Muhasebe & Finans", permissions = listOf("Finance", "Reports", "CurrentAccounts")),
            Department(id = "dep-5", tenant_id = DEMO_TENANT_ID, name = "Teknik Servis & Bakım", permissions = listOf("Maintenance", "Rooms"))
        )
    )

    // 9. Suppliers & Categories
    val supplierCategoriesState = MutableStateFlow<List<SupplierCategory>>(
        listOf(
            SupplierCategory(id = "sc-1", tenant_id = DEMO_TENANT_ID, name = "Gıda & İçecek"),
            SupplierCategory(id = "sc-2", tenant_id = DEMO_TENANT_ID, name = "Tekstil & Buklet"),
            SupplierCategory(id = "sc-3", tenant_id = DEMO_TENANT_ID, name = "Kimyasal & Temizlik")
        )
    )

    val suppliersState = MutableStateFlow<List<Supplier>>(
        listOf(
            Supplier(id = "sup-1", tenant_id = DEMO_TENANT_ID, category_id = "sc-1", name = "Akdeniz Gıda Toptan", contact_info = "+90 242 555 01 02"),
            Supplier(id = "sup-2", tenant_id = DEMO_TENANT_ID, category_id = "sc-2", name = "Ege Tekstil Sanayi", contact_info = "+90 232 444 03 04")
        )
    )

    // 10. Agencies
    val agenciesState = MutableStateFlow<List<Agency>>(
        listOf(
            Agency(id = "ag-1", tenantId = DEMO_TENANT_ID, name = "Booking.com", contactInfo = "support@booking.com", commissionRate = 15.0, phone = "+90 212 900 00 01"),
            Agency(id = "ag-2", tenantId = DEMO_TENANT_ID, name = "OtelZ", contactInfo = "acente@otelz.com", commissionRate = 12.0, phone = "+90 216 800 00 02"),
            Agency(id = "ag-3", tenantId = DEMO_TENANT_ID, name = "ETS Tur", contactInfo = "rezervasyon@etstur.com", commissionRate = 14.0, phone = "+90 212 700 00 03")
        )
    )

    // 11. Price Periods
    val pricePeriodsState = MutableStateFlow<List<PricePeriod>>(
        listOf(
            PricePeriod(id = "pp-1", tenantId = DEMO_TENANT_ID, roomType = "Deluxe", name = "Yaz Sezonu", startDate = "2026-06-01", endDate = "2026-09-30", price = 3500.0),
            PricePeriod(id = "pp-2", tenantId = DEMO_TENANT_ID, roomType = "Suite", name = "Yaz Sezonu", startDate = "2026-06-01", endDate = "2026-09-30", price = 5000.0),
            PricePeriod(id = "pp-3", tenantId = DEMO_TENANT_ID, roomType = "Standard", name = "Yaz Sezonu", startDate = "2026-06-01", endDate = "2026-09-30", price = 2500.0)
        )
    )
}
